module.exports = __webpack_public_path__ + "img/send-01.a11fef1b.svg";